import { MobiDocument } from './MobiDocument';

export class MedecinDocument extends MobiDocument{
    //Attributs from DB
    private _id : string;
    private _rev : string;
    private id : number;
    private nom :string;
    private telephone : string;

    public constructor(medecin : any){
        super()
        this._id = medecin._id;
        this._rev = medecin._rev;
        this.id = medecin.id;
        this.nom = medecin.nom;
        this.telephone = medecin.telephone;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getNom() :string {
        return this.nom;
    }

    public setNom(nom :string): void {
        this.nom = nom;
    }

    public getTelephone(): string {
        return this.telephone;
    }

    public setTelephone(telephone: string): void {
        this.telephone = telephone;
    }



}